<div class="drag-and-drop-icon">
  <div><mat-icon svgIcon="upload" style="transform: scale(.95)"></mat-icon></div>
</div>
<div class="drag-and-drop-text">
  <b>{{ 'file-upload.drag-and-drop-info.text' | translate }}</b>
</div>
